import { useState } from "react";

export default function ContactFormSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<
    "idle" | "success" | "error"
  >("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("idle");

    // バリデーション
    if (!formData.name || !formData.email || !formData.message) {
      setSubmitStatus("error");
      setIsSubmitting(false);
      return;
    }

    // メールアドレスの簡易バリデーション
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setSubmitStatus("error");
      setIsSubmitting(false);
      return;
    }

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch(
        "https://readdy.ai/api/form/d663djeaa283heu4vme0",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formBody.toString(),
        },
      );

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
        });
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact-form" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-navy mb-4">
            お問い合わせ
          </h2>
          <p className="text-lg text-gray-600">
            まずはお気軽にご相談ください。無料でご相談を承ります。
          </p>
        </div>

        <div className="bg-accent-light rounded-2xl p-8 lg:p-12">
          <div className="text-center py-10">
            <p className="mb-6 text-gray-700">
              お問い合わせは下記フォームよりお願いいたします。
            </p>

            <a
              href="https://forms.gle/XVuNpafAVyfPMMSE9"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all"
            >
              お問い合わせフォームを開く
            </a>
          </div>
        </div>

        {/* 連絡先情報 */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            お急ぎの方は、お電話でもお問い合わせいただけます。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href="tel:090-2199-3209"
              className="flex items-center gap-2 text-cta hover:text-cta-hover transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span className="font-semibold">090-2199-3209</span>
            </a>
            <a
              href="mailto:ysstudio.kobe@gmail.com"
              className="flex items-center gap-2 text-cta hover:text-cta-hover transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-xl"></i>
              <span className="font-semibold">ysstudio.kobe@gmail.com</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
